/**
 * The phone header's fallback title, derived from the route (MAR-1350).
 *
 * Most pages name themselves: `PageContent`, the docs viewer and the sheet toolbar teleport a
 * breadcrumb leaf into the app bar (`useAppBar.ts`). A few never claim the bar — the chat home and an
 * open conversation above all — and below `sm` the bar would then be a lone "+". `AppBar.vue` shows
 * this fallback ONLY while nothing has claimed the bar, so a page's own title always wins and the two
 * are never on screen together.
 *
 * Returns an i18n key, not copy, so the wording stays in the locale files and follows the user's
 * language. `null` means "no honest name for this route": the bar then shows nothing rather than a
 * wrong one.
 */

/** Every entry is a distinct top-level section, so the order does not matter. */
const SECTIONS: readonly [prefix: string, key: string][] = [
  ['/app/c', 'nav.chat'],
  ['/app/history', 'nav.history'],
  ['/app/clients', 'nav.clients'],
  ['/app/cases', 'nav.clients'],
  ['/app/laws', 'nav.laws'],
  ['/app/sheets', 'sheets.title'],
  ['/app/workflows', 'nav.workflows'],
  ['/app/library', 'nav.library'],
  ['/app/briefs', 'nav.briefs'],
  ['/app/contract-review', 'nav.contractReview'],
  ['/app/guidance', 'nav.guidance'],
  ['/app/agent', 'nav.agent'],
  ['/app/settings', 'nav.settings'],
  ['/app/admin', 'nav.admin'],
]

export function mobileHeaderTitleKey(path: string): string | null {
  if (path === '/app' || path === '/app/') return 'nav.chat'
  for (const [prefix, key] of SECTIONS) {
    // A segment boundary, so `/app/historyx` is not "History".
    if (path === prefix || path.startsWith(`${prefix}/`)) return key
  }
  return null
}
